import React from "react";
import { Checkbox } from "@folio/stripes/components";
import { useIntl } from "react-intl";
import { Controller } from "react-hook-form";
/**
 * "Neodesílat do Národních autorit" checkbox of the person create forms: a
 * checked person becomes a local-only authority kept in ReČeK and never sent
 * to NK authorities (payload `localOnly: true`, DB-635). Create only — the
 * backend ignores the flag on update.
 */
export var LocalOnlyCheckbox = function (_a) {
    var control = _a.control;
    var formatMessage = useIntl().formatMessage;
    return (React.createElement(Controller, { control: control, name: "localOnly", render: function (_a) {
            var _b = _a.field, value = _b.value, onChange = _b.onChange;
            return (React.createElement(Checkbox, { label: formatMessage({
                    id: "ui-br-agency.person.localOnly.field.label",
                }), checked: !!value, onChange: function (e) {
                    return onChange(e.target.checked);
                } }));
        } }));
};
